/**
 * Repairs common invalid JSON patterns from the backend, 
 * such as unquoted string values.
 */
export const repairAndParseJSON = (data) => {
    if (!data) return null;
    
    // If it's already an object, just return it
    if (typeof data === 'object') return data;
    
    if (typeof data !== 'string') return data;
    
    try {
        // Try standard parsing first
        return JSON.parse(data);
    } catch (e) {
        try {
            // Repair: add quotes to unquoted values like :MOTORS or :MOTOR COMP
            // This regex looks for : followed by a letter, and captures any character that is not a quote, comma, brace, or bracket.
            const repaired = data.replace(/:\s*([A-Za-z][^",\{\}\[\]]*?)\s*([,}])/g, ':"$1"$2');
            return JSON.parse(repaired);
        } catch (error) {
            console.error("JSON Repair failed:", error);
            return null;
        }
    }
};
